import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CountryData, ZipDeatils, GetDistanceToPlantDataInputs, DistanceToPlantReport } from './types/DistanceToPlantReport';


@Injectable({
  providedIn: 'root'
})
export class DistanceToPlantService {

  baseurl = environment.apiBaseUrl + 'DistanceToPlantReport/';

  constructor(protected http: HttpClient) { }

  getAllCountries(): Observable<CountryData[]> {
    return this.http.get<CountryData[]>(this.baseurl + 'getcountries');
  }

  getZipDetails(zip: string, country: string): Observable<ZipDeatils> {
    return this.http.get<ZipDeatils>(this.baseurl + 'getzipdetails/' + zip + '/' + country);
  }

  getReportData(inputs: GetDistanceToPlantDataInputs): Observable<DistanceToPlantReport[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post<DistanceToPlantReport[]>(this.baseurl + 'getdistancetoplantreportdata', JSON.stringify(inputs, null, 2), httpOptions);
  }
}